const ShareIcon = ({ width = 30, height = 30, color = "#001e5a" }) => (
  <svg
    height={height}
    width={width}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill={color}
    stroke={color}
    strokeWidth="0.00512"
  >
    <path d="M512,230.431L283.498,44.621v94.807C60.776,141.244-21.842,307.324,4.826,467.379 c48.696-99.493,149.915-138.677,278.672-143.14v92.003L512,230.431z" />
  </svg>
);

export default ShareIcon;